Globals = {};

Globals.create = false;
Globals.createType = 0;
Globals.canvas = null;
Globals.editing = false;

module.exports = Globals;
